// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M4.77923 1H6.71559L9.21559 8.33333H14.7844L17.2844 1H19.2207L23.6748 14.3621L12 23.2572L0.325195 14.3621L4.77923 1Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-gitlab-filled')
export default class LogoGitlabFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-gitlab-filled',
    }
  }
}
